export enum ELinkId {
  HOW_TO_START_WB = 'howToStartWb',
  WHAT_CAN_BE_SOLD = 'whatCanBeSold',
  CERTIFICATION = 'certification',
  SALES_MODEL = 'salesModel',
  ALL_MATERIALS = 'allMaterials',
  LOYALTY_PROGRAM = 'loyaltyProgram',
  ACCOUNT_REGISTRATION = 'accountRegistration',
  AVAILABLE_SALES_MODELS_FBS = 'availableSalesModelsFBS',
  ORDER_RETURNS = 'orderReturns',
  EXPORT = 'export',
  SIZE = 'size',
}

export type TLink = {
  text: string;
  route: string;
  id: ELinkId;
  isResolveUrl?: boolean;
};

type TBlock = {
  title: string;
  description: string;
};

export enum ECardModifier {
  WITH_LINKS = 'with-links',
  WITH_BLOCKS = 'with-blocks',
}

export type TCardWithLinks = {
  cardModifier: ECardModifier;
  title: string;
  description: string;
  links: Array<TLink>;
  buttonLink: string;
};

export type TCardWithBlocks = {
  cardModifier: ECardModifier;
  blocks: Array<TBlock>;
};

export type TSupportConfig = {
  title: string;
  button: string;
  cards: Array<TCardWithLinks | TCardWithBlocks>;
};
